import React, { Fragment, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { ModalFooter } from "react-bootstrap";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useEffect } from "react";
import { getPolicyDetailsById } from "../../../api";
import { getProductById } from "../../../api";
import Information from "../policies/view-policy-details/modal-components/information";
import Validity from "../policies/view-policy-details/modal-components/validity";
import Fees from "../policies/view-policy-details/modal-components/fees";
import ComboModal from "../policies/view-policy-details/modal-components/combo-modal";


const ViewProductModal = (props) => {
    const { isOpen, toggle, selectedProductData, model, variant, changeExistingHistory, changeNewHistory, mappingFuel, mappingTransmission } = props;
    const [viewPolicyDetailsByType, setViewPolicyDetailsByType] = useState(0);
    const [productData, setProductData] = useState({});
    // const steps = [
    //     { key: 0, name: 'Information', component: <Information data={selectedProductData}/> },
    //     { key: 1, name: 'Fees', component: <Fees data={selectedProductData}/> },
    //     { key: 2, name: 'Validity (in Days)', component: <Validity data={selectedProductData} /> },
    //     { key: 3, name: 'Combo EA Fees Distribution', component: <ComboModal data={selectedProductData} /> }
    // ]

    const steps = [
        { key: 0, name: 'Information', component: <Information data={selectedProductData} /> },
        { key: 1, name: 'Fees', component: <Fees data={selectedProductData} /> },
        { key: 2, name: 'Validity (in Days)', component: <Validity data={selectedProductData} /> },
        ...(Array.isArray(selectedProductData?.comboFields) && selectedProductData.comboFields.length > 0
            ? [{ key: 3, name: 'Combo EA Fees Distribution', component: <ComboModal data={selectedProductData} /> }]
            : [])
    ];


    // Debug: log props and selectedProductData whenever they change
    useEffect(() => {
        console.log('ViewProductModal props:', props);
        console.dir(selectedProductData, { depth: null });
    }, [props, selectedProductData]);

    // Debug: log when modal opens (inspect payload delivered at open)
    useEffect(() => {
        if (isOpen) {
            console.log('ViewProductModal opened. selectedProductData at open:', selectedProductData);
        }
    }, [isOpen, selectedProductData]);

    const handleNextTabByClick = (nextStepValue, steps) => {
        if (nextStepValue < steps.length) {
            // console.log(viewPolicyDetailsByType, 'viewPolicyDetailsByType');
            setViewPolicyDetailsByType(viewPolicyDetailsByType + 1);
        }
    }

    const handlePreviousTabByClick = (previousStepValue, steps) => {
        if (previousStepValue >= 0) {
            setViewPolicyDetailsByType(viewPolicyDetailsByType - 1);
        }
    }


    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
                <ModalHeader toggle={toggle} className="pb-0 border-0">
                    {"Product Details"}
                </ModalHeader>
                <ModalBody className="pt-4">
                    <Nav className="nav-pills nav-justified">
                        {
                            steps && steps.map((item, i) => {
                                return (
                                    <NavItem key={i}>
                                        <NavLink href="#javascript" className={viewPolicyDetailsByType === item.key ? 'active' : ''} onClick={() => setViewPolicyDetailsByType(item.key)}>
                                            <span style={{ whiteSpace: 'nowrap' }}> {item.name} </span>
                                        </NavLink>
                                    </NavItem>
                                )
                            })
                        }
                    </Nav>
                    <TabContent activeTab={viewPolicyDetailsByType}>
                        {
                            steps && steps.map((item, i) => {
                                return (
                                    <TabPane className={item.key === 0 ? "fade show" : ""} tabId={item.key} key={i}>
                                        {item.component}
                                    </TabPane>
                                )
                            })
                        }
                    </TabContent>
                </ModalBody>
                <ModalFooter>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-6">
                                {parseInt(viewPolicyDetailsByType) !== 0 && (
                                    <Button
                                        className="mr-2 btnCustom"
                                        outline
                                        color="info"
                                        size="md"
                                        onClick={(e) => handlePreviousTabByClick(parseInt(viewPolicyDetailsByType) - 1, steps)}
                                    >
                                        {"Previous"}
                                    </Button>
                                )}
                            </div>
                            <div className="col-6 text-right">
                                {parseInt(viewPolicyDetailsByType) < 2 && (
                                    <Button
                                        className="btnCustom"
                                        outline
                                        color="info"
                                        size="md"
                                        onClick={(e) => handleNextTabByClick(parseInt(viewPolicyDetailsByType) + 1, steps)}
                                    >
                                        {"Next"}
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ViewProductModal;